/**
 * สำหรับ claim detail: API อาจส่ง mobiles[] แทน mobileBrandName / mobileModelName แค่ root
 * รวมเป็นข้อความคั่นด้วย ", " สำหรับแสดงในฟอร์ม
 */
export const getClaimMobileBrandsText = (claim) => {
  if (!claim) {
    return '';
  }
  if (Array.isArray(claim.mobiles) && claim.mobiles.length > 0) {
    return claim.mobiles
      .map((m) => m.mobileBrandName)
      .filter((s) => s != null && s !== '')
      .join(', ');
  }
  return claim.mobileBrandName ?? '';
};

export const getClaimMobileModelsText = (claim) => {
  if (!claim) {
    return '';
  }
  if (Array.isArray(claim.mobiles) && claim.mobiles.length > 0) {
    return claim.mobiles
      .map((m) => m.mobileModelName)
      .filter((s) => s != null && s !== '')
      .join(', ');
  }
  return claim.mobileModelName ?? '';
};

/**
 * จาก warrantyMobileLabels[] แสดงเป็นข้อความคั่นด้วย ", " (รูปแบบ: ยี่ห้อ - รุ่น ต่อรายการ)
 */
export const getWarrantyMobileLabelsDisplayText = (labels) => {
  if (!Array.isArray(labels) || labels.length === 0) {
    return '';
  }
  return labels
    .map((x) => {
      const brand = x?.mobileBrandName ?? '';
      const model = x?.mobileModelName ?? '';
      if (brand && model) {
        return `${brand} - ${model}`;
      }
      return brand || model;
    })
    .filter((s) => s != null && s !== '')
    .join(', ');
};

export const applyClaimMobilesDisplayToFormValues = (claim) => ({
  mobileBrandName: getClaimMobileBrandsText(claim),
  mobileModelName: getClaimMobileModelsText(claim),
  warrantyMobileLabelsDisplay: getWarrantyMobileLabelsDisplayText(claim?.warrantyMobileLabels),
});
